import styled, { css } from 'styled-components'

const MEDIAS = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl']

const BREAKPOINTS = {
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
}

const MOB_TEXT_FONT_SIZES = [0.67, 0.83, 1, 1.125, 1.375]
const WEB_TEXT_FONT_SIZES = [0.67, 0.83, 1, 1.125, 1.75]

const getFontSize = (size = 'md', fontSizes) => {
    for (let i = 0; i < MEDIAS.length; i++) {
        if (size === MEDIAS[i]) {
            return fontSizes[i]
        }
    }
}

const Text = styled.p`
    width: ${(props) => (props.width ? props.width : 'auto')};
    max-width: 100%;
    font-size: ${(props) =>
        props.size
            ? isNumber(props.size)
                ? `${props.size}px`
                : getFontSize(props.size, MOB_TEXT_FONT_SIZES) + 'em'
            : 'inherit'};

    ${(props) =>
        props.size
            ? css`
                  @media (min-width: ${BREAKPOINTS.lg + 'px'}) {
                      font-size: ${isNumber(props.size)
                          ? `${props.size}px`
                          : getFontSize(props.size, WEB_TEXT_FONT_SIZES) +
                            'em'};
                  }
              `
            : ''};

    padding: ${(props) => (props.padding ? props.padding : '0px')};
    margin: ${(props) => (props.margin ? props.margin : null)};
    color: ${(props) => props.color};
    text-align: ${(props) => (props.align ? props.align : 'left')};
    font-weight: ${(props) => {
        const weight = props.bold || props.weight
        if (weight) {
            return parseInt(weight, 10) > 0 ? weight : '700'
        }
        return 'normal'
    }};
    ${(props) => (props.block ? 'display: block;' : '')} ${(props) =>
        props.short
            ? 'text-overflow: ellipsis; white-space: nowrap; overflow: hidden; width: auto;'
            : ''};
    ${(props) => (props.shadow ? `text-shadow: ${props.shadow};` : '')};
    ${(props) => (props.opacity ? `opacity: ${props.opacity};` : '')};
    ${(props) => (props.height ? `height: ${props.height};` : '')};
    ${(props) => (props.overflow ? `overflow: ${props.overflow};` : '')};
    ${(props) => props.condensed && 'font-family: Roboto Condensed'};
    ${(props) => {
        if (props.lineHeight) {
            return `line-height: ${props.lineHeight}`
        }
    }};
    box-sizing: border-box;
    text-decoration: ${(props) => (props.strike ? 'line-through' : 'none')};
`

const isNumber = (value) => typeof value === 'number'

export default Text
